import AskTeamAssistV2, { isHoldingQuestions } from 'actions/team_assist_v2/ask_team_assist_v2';
import isTeamAssistV2Enabled from 'actions/team_assist_v2/lib/is_team_assist_v2_enabled';
import { TeamAssistV2AnswerStatus } from 'actions/team_assist_v2/lib/team_assist_v2_answer';

export default class RetryTeamAssistV2 {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, turnId }) {
    if (!isTeamAssistV2Enabled(this.context.stores.appFeatures.get())) {
      return;
    }
    if (!customerId || !this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const { teamAssistsV2 } = this.context.stores.customers.storesFor(customerId);
    // Ask would hold the question, so the failed turn stays to retry later.
    if (isHoldingQuestions(teamAssistsV2) || !teamAssistsV2.has({ id: turnId })) {
      return;
    }
    const failed = teamAssistsV2.find(turnId);
    const turns = teamAssistsV2.findAll();
    // Only the newest turn retries, so asking again at the end keeps its place.
    if (!isFailed(failed) || turns[turns.length - 1].id !== turnId) {
      return;
    }

    teamAssistsV2.set(turns.filter(turn => turn.id !== turnId));
    // glados builds history per conversation, so the question goes back to the
    // one it was asked in.
    this.context.executeAction(AskTeamAssistV2, {
      conversationId: failed.conversationId,
      customerId,
      displayedMessage: failed.displayedMessage,
      isRetry: true,
      question: failed.question,
    });
  }
}

function isFailed(turn) {
  return Boolean(turn.answer) && turn.answer.status === TeamAssistV2AnswerStatus.error;
}
